export default __webpack_public_path__ + "static/media/toogle.b7dbb2ca.svg";